<template>
  <div>
  <navbar/>
  <features/> 
  </div>
</template>

<script>

import features from '@/components/features.vue';
import navbar from '@/components/navbar.vue';

export default {
  name: 'FeaturesView',
  components: {
    navbar, 
    features, 
  }
}
</script>
